import Notification from "@/services/echo-manager/notification";

export default class VipOverflow extends Notification
{
    handle() {
        //
    }
}
